import { useCallback } from 'react';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

import useErrorHandling from '@swf/core/hooks/useErrorHandling';
import useRequestBase from '@swf/core/hooks/useRequest';

const useRequest = () => {
  const request = useRequestBase();
  const { addError } = useErrorHandling();

  return useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <T = any>(options: Parameters<typeof request>[0]) =>
      request<T>(options).pipe(
        catchError((error) => {
          addError(error);
          return EMPTY;
        })
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [request]
  );
};

export default useRequest;
